import { ApolloError } from '@apollo/client';

import { useExpenseQuery } from 'core/graphql';

import { IExpenseDetail } from './types';
import { isPermissionDeniedError } from './errors';

interface IExpenseHook {
  expense?: IExpenseDetail;
  loading: boolean;
  error?: ApolloError;
  permissionDenied: boolean;
  refetch: () => void;
}

/** Loads a single expense for the edit form (TZ §3.7). */
export const useExpense = (id?: string): IExpenseHook => {
  const { data, loading, error, refetch } = useExpenseQuery({
    variables: { id: id || '' },
    skip: !id,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  return {
    expense: data?.expense ?? undefined,
    loading,
    error,
    permissionDenied: isPermissionDeniedError(error),
    refetch: () => {
      refetch();
    },
  };
};
